import { ChangeDetectionStrategy, Component, DestroyRef, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';

import { ConfirmRequest, ConfirmService } from 'app/core/services/confirm.service';

/**
 * Host global do ConfirmService: renderiza o modal de confirmação DaisyUI e resolve a Promise
 * aberta pelo serviço. Deve ser montado uma única vez (no app.component).
 */
@Component({
    selector: 'oab-confirm-host',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { 'data-theme': 'oab' },
    templateUrl: './confirm-host.component.html',
})
export class OabConfirmHostComponent implements OnInit, OnDestroy {
  private confirm = inject(ConfirmService);
  private destroyRef = inject(DestroyRef);

  readonly current = signal<ConfirmRequest | null>(null);
  private sub?: Subscription;

  ngOnInit(): void {
    this.sub = this.confirm.requests.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((req) => this.current.set(req));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  answer(confirmed: boolean): void {
    const req = this.current();
    this.current.set(null);
    req?.resolve(confirmed);
  }
}
